{
  "name": "rpc-front",
  "version": "0.0.3-rc.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build:local": "ng build --configuration=local",
    "build:dev": "ng build --configuration=dev",
    "build:rec": "ng build --configuration=rec",
    "build:prd": "ng build --configuration=prd",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.1.5",
    "@angular/common": "21.1.5",
    "@angular/compiler": "21.1.5",
    "@angular/core": "21.1.5",
    "@angular/forms": "21.1.5",
    "@angular/platform-browser": "21.1.5",
    "@angular/platform-browser-dynamic": "21.1.5",
    "@angular/router": "21.1.5",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@popperjs/core": "^2.11.8",
    "ag-grid-angular": "^35.3.0",
    "ag-grid-community": "^35.3.0",
    "ag-grid-enterprise": "^35.3.0",
    "angular-oauth2-oidc": "^20.0.2",
    "angular-oauth2-oidc-jwks": "^20.0.0",
    "bootstrap": "^5.3.8",
    "bootstrap-icons": "^1.10.5",
    "dayjs": "^1.11.10",
    "jwt-decode": "^4.0.0",
    "ngx-device-detector": "^11.0.0",
    "ngx-toastr": "^20.0.5",
    "rxjs": "~7.8.2",
    "tinymce": "^8.3.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.16.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "21.2.0",
    "@angular-eslint/eslint-plugin": "21.2.0",
    "@angular-eslint/eslint-plugin-template": "21.2.0",
    "@angular-eslint/schematics": "21.2.0",
    "@angular-eslint/template-parser": "21.2.0",
    "@angular/build": "21.1.5",
    "@angular/cli": "21.1.5",
    "@angular/compiler-cli": "21.1.5",
    "@angular/localize": "21.1.5",
    "@softarc/eslint-plugin-sheriff": "^0.19.6",
    "@softarc/sheriff-core": "^0.19.6",
    "@types/bootstrap": "^5.2.10",
    "@types/jasmine": "~6.0.0",
    "@typescript-eslint/eslint-plugin": "^8.56.1",
    "@typescript-eslint/parser": "^8.56.1",
    "eslint": "^8.57.0",
    "jasmine-core": "~6.1.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.2.0",
    "prettier": "3.8.1",
    "typescript": "~5.9.3"
  }
}
